import {useState} from 'react';

import {
	FeaturesEnum,
	HelpCenterEnum,
	HomeEnum,
	SendMessageAllowedHourEnum,
	ServicesEnum,
} from 'presentation/constants';
import {useLocation, useNavigate} from 'react-router-dom';
import {GenderEnum} from 'domain/usecases/others/selection-flow/beneficiary-v3';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {isWithinAllowedHours} from 'presentation/utils/isWithinAllowedHours';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {useHostName} from 'presentation/hooks';

const ADULT_AGE = 18;

export function useHelp() {
	const navigate = useNavigate();
	const {isGndiSaoPaulo, isNotredameSaude} = useHostName();
	const [openChatsModalState, setOpenChatsModalState] = useState(false);
	const [openInformativeModalState, setOpenInformativeModalState] = useState(false);
	const {state: routeState} = useLocation();
	const flSexoUsuarioC = useAccountDataStore(
		store => store.accountData.beneficiary.flSexoUsuarioC,
	);
	const idadeC = useAccountDataStore(store => store.accountData.beneficiary.idadeC);
	const isFemale = flSexoUsuarioC === GenderEnum.FEMALE || flSexoUsuarioC === GenderEnum.WOMAN;
	const isAdult = idadeC >= ADULT_AGE;
	const canShowCanalDelas = isFemale && isAdult;
	const canShowFaq = isGndiSaoPaulo || isNotredameSaude;
	const {isEnabled: isTalkToUsFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_TALK_TO_US_MESSAGE,
	);

	const handleBack = () => {
		if (routeState?.includes(ServicesEnum.SERVICES)) {
			navigate(routeState);
			return;
		}

		navigate(HomeEnum.HOME_PAGE);
	};

	const handleOpenChatsModal = () => {
		setOpenChatsModalState(true);
	};

	const handleCloseChatsModal = () => {
		setOpenChatsModalState(false);
	};

	const handleCloseInformativeModal = () => {
		setOpenInformativeModalState(false);
	};

	const handleGoFormSendMessage = () => {
		if (isTalkToUsFeatureFlagEnabled) {
			const isAllowed = isWithinAllowedHours(
				SendMessageAllowedHourEnum.StartHour,
				SendMessageAllowedHourEnum.EndHour,
			);

			if (!isAllowed) {
				setOpenInformativeModalState(true);
				return;
			}
		}
		navigate(HelpCenterEnum.SEND_MESSAGE);
	};

	const handleGoToAddresses = () => {
		navigate(HelpCenterEnum.SERVICE_POINTS_ADDRESSES);
	};

	return {
		canShowCanalDelas,
		canShowFaq,
		isTalkToUsFeatureFlagEnabled,
		openChatsModalState,
		openInformativeModalState,
		handleBack,
		handleOpenChatsModal,
		handleCloseChatsModal,
		handleGoFormSendMessage,
		handleCloseInformativeModal,
		handleGoToAddresses,
	};
}
